<template>
  <div>
    <section class="login-container boxed-login">
      <div class="container">
        <div class="col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4">
          <div class="login-form-container">
            <div class="j-forms" id="forms-login" novalidate="novalidate">
              <div class="login-form-header">
                <div class="logo">
                  <img class="logo-pic" src="../../assets/img/logo3.png" alt="logo">
                </div>
              </div>
              <div class="login-form-content">
                <!-- start login -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="login">
                      <i class="zmdi zmdi-account"></i>
                    </label>
                    <input class="form-control login-frm-input" type="text" placeholder="姓名*" name="user_name" v-model="name" v-validate="'required'">
                    <i v-show="errors.has('user_name')" class="fa fa-warning"></i>
                    <small v-show="errors.has('user_name')" class="help text-danger">這是必填項目喔
                    </small>
                  </div>
                </div>
                <!-- end login -->
                <!-- start login -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="login">
                      <i class="far fa-envelope"></i>
                    </label>
                    <input class="form-control login-frm-input" type="text" id="login" name="email" placeholder="Email*" v-model="email" v-validate="'required|email'">
                    <i v-show="errors.has('email')" class="fa fa-warning"></i>
                    <small v-show="errors.has('email')" class="help text-danger">這是必填項目喔</small>
                  </div>
                </div>
                <!-- end login -->
                <!-- start password -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="password">
                      <i class="zmdi zmdi-key"></i>
                    </label>
                    <input class="form-control login-frm-input" type="password" name="password" id="password" placeholder="密碼*" v-model="password" v-validate="'required'" ref="password">
                    <i v-show="errors.has('password')" class="fa fa-warning"></i>
                    <small v-show="errors.has('password')" class="help text-danger">這是必填項目喔</small>
                  </div>
                </div>
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="password">
                      <i class="zmdi zmdi-key"></i>
                    </label>
                    <input class="form-control login-frm-input" type="password" name="repassword" id="repassword" placeholder="確認密碼*" v-validate="'required|confirmed:password'" data-vv-as="password">
                    <i v-show="errors.has('repassword')" class="fa fa-warning"></i>
                    <small v-show="errors.has('repassword')" class="help text-danger">兩次密碼不同</small>
                  </div>
                </div>
                <div class="unit">
                  <div class="input login-input">
                    <label class="checkbox" for="agreement">
                      <input type="checkbox" name="agreement" id="agreement" placeholder="確認密碼*" v-validate="'required'">
                      <i></i>
                      <small>我已閱讀並同意 <b class="text-info pointer" @click="webTermModal=true">網站使用條款</b> 與 <b class="text-info pointer" @click="privacyTermModal=true">隱私權政策</b></small>
                    </label>
                    <i v-show="errors.has('agreement')" class="fa fa-warning"></i>
                    <small v-show="errors.has('agreement')" class="help text-danger">這是必填項目喔</small>
                  </div>
                </div>
                <!-- end password -->
                <!-- start login -->
                <!-- <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="login">
                      <i class="fa fa-building"></i>
                    </label>
                    <input class="form-control login-frm-input" type="text" placeholder="公司或團隊名稱" v-model="company_name" @keydown.enter="signup">
                  </div>
                </div> -->
                <!-- end login -->
              </div>
              <div class="login-form-footer" style="padding-top:0px;margin-bottom:2px;">
                <button v-if="loading" class="btn-block btn btn-success" disabled>
                  建立帳號中...
                </button>
                <button v-else class="btn-block btn btn-success" v-on:click="signup">送出註冊</button>
              </div>
              <router-link class="" to="login">
                已有帳號？點此登入
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!--Footer Start Here -->
      <footer class="login-page-footer">
      </footer>
      <!--Footer End Here -->
    </section>
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
    <!-- modal template start-->
    <div v-if="webTermModal" @keyup.esc="webTermModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="webTermModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header">
                <h3 class="text-center">Flowneat網站使用條款</h3>
              </div>
            </div>
            <div class="modal-body scroll">
              <div name="body">
                <webUseTerm></webUseTerm>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-default" @click="webTermModal=false">
                  關閉
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="privacyTermModal" @keyup.esc="privacyTermModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="privacyTermModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header">
                <h3 class="text-center">Flowneat隱私權政策</h3>
              </div>
            </div>
            <div class="modal-body scroll">
              <div name="body">
                <PrivacyTerm></PrivacyTerm>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-default" @click="privacyTermModal=false">
                  關閉
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
  </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import webUseTerm from './WebUseTerm'
import PrivacyTerm from './PrivacyTerm'
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'

export default {
  name: 'signup',
  components: { Simplert,webUseTerm,PrivacyTerm },
  data() {
    return {
      email: '',
      password: '',
      name: '',
      company_name: '',
      refs: this.$refs,
      loading: false,
      webTermModal: false,
      privacyTermModal: false,
    }
  },
  methods: {
    signup() {
      this.validateBeforeSubmit();
    },
    toSignup() {
      const vm = this;
      this.loading = true
      this.axios.post('users', {
        user: {
          email: this.email,
          name: this.name,
          password: this.password,
          company_name: this.company_name
        }
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          var obj = {
            isShown: true,
            title: '驗證您的電子信箱',
            message: '請檢查您的信箱，確認驗證信，也要注意看看垃圾信箱喔！',
            type: 'success',
            customCloseBtnText: '確定',
            onClose: vm.onClose
          }
        } else if (response['data']['status'] == 'fail') {
          var obj = {
            isShown: true,
            title: '這個的Email已經註冊',
            message: '您的Email已經註冊，請直接登入。若忘記密碼，請使用忘記密碼功能，重設新密碼',
            type: 'warning',
            customCloseBtnText: '關閉'
          }
        }
        vm.loading = false
        vm.refs.simplert.openSimplert(obj);
      })
      .catch(function(error) {
        vm.loading = false
        console.log('error:', error)
        var obj = {
          isShown: true,
          title: '無法註冊',
          message: '目前無法進行註冊，已連繫管理員，請您稍後再試',
          type: 'warning',
          customCloseBtnText: '關閉'
        }
        vm.refs.simplert.openSimplert(obj);
      });
    },
    onClose(){
      this.$router.push('login')
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.toSignup();
        }
      });
    },
  }
}
</script>


// WEBPACK FOOTER //
// Signup.vue?525fa02a